
editBotConnectorBoxController.$inject = ['$scope', 
                                    '$mdDialog',
                                    'elementData'];
export function editBotConnectorBoxController($scope, 
                                        $mdDialog,
                                        elementData) {


  $scope.ok = ok;
  $scope.cancel = cancel;

  init();

  function ok() {
    $mdDialog.hide({type: 'ok', data: $scope.elementData});
  }

  function cancel() {
    $mdDialog.cancel();
  }


  function init() {
    $scope.elementData = elementData;
  }
}
